export default __webpack_public_path__ + "locales/vi/PortalUnavailable.json?hash=d0f74eac12ba9d41f2b5d7fad9dac22a";